import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '../../../../../components/Button';

const Trade = ({ i18n, history }) => {
  const lang = (type, params) => i18n(`economy.tab8.${type}`, { ...params });

  return (
    <div className='card-instruction-detail'>
      <div className='title'>{lang('title')}</div>
      <main>
        <div className='instruction-wrap'>
          <div dangerouslySetInnerHTML={{ __html: lang('step.instruction') }} />
          <a
            className='the-btn mtop16 btn btn-primary'
            href='https://www.cbp.gov/'
            target='_blank'
            without
            rel='noopener noreferrer'
            style={{ width: 'max-content' }}
          >
            {lang('step.cta1')}
          </a>

          <div
            className='mtop16'
            dangerouslySetInnerHTML={{ __html: lang('step.instruction1') }}
          />
          <a
            className='the-btn mtop16 btn btn-primary'
            href='https://travel.state.gov/'
            target='_blank'
            without
            rel='noopener noreferrer'
            style={{ width: 'max-content' }}
          >
            {lang('step.cta2')}
          </a>

          <div
            className='mtop16'
            dangerouslySetInnerHTML={{ __html: lang('step.instruction2') }}
          />
          <Button
            color='outline-info'
            className='mtop16'
            onClick={() => history.push('/economy/trade-question/form')}
          >
            {lang('step.cta3')}
          </Button>
        </div>
      </main>
    </div>
  );
};

Trade.propTypes = {
  i18n: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default compose(connect(mapStateToProps), withRouter)(Trade);
